<template>
    <page-shell v-if="locations" :title="pageTitle">
        <template v-if="locations.length > 1" #toolbar>
            <div class="location-select">
                <v-select v-model="selectedLocation" :options="locations" :clearable="false" label="name"></v-select>
            </div>
        </template>
        <div v-if="selectedLocation">
            <div v-if="selectedContentBlocks?.length > 0">
                <render-content-blocks :content-blocks="selectedContentBlocks" />
            </div>
            <div v-else>
                <p>No specific information for {{ selectedLocation.name }}</p>
            </div>
        </div>
    </page-shell>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { getContentBlocks } from "../../api/rest";
import { fetchUserData } from "../../api/graphql/users";
import useCurrentUserStore from "../../store/userStore";
import RenderContentBlocks from "../content-block/RenderContentBlocks.vue";
import PageShell from "../shared/PageShell.vue";
const store = useCurrentUserStore();

const locations = ref([]);

const selectedLocation = ref(null);

const locationContentBlocks = ref({});

onMounted(async () => {
    if (!store.currentUser?.locations) {
        await fetchUserData();
    }
    locations.value = store.currentUser.locations;
    if (locations.value.length === 1) {
        selectedLocation.value = locations[0];
    }
});

watch(selectedLocation, async (location) => {
    if (location) {
        const locationId = location.id;
        if (locationContentBlocks.value[locationId]) {
            const contentBlocks = await getContentBlocks("operator-info", locationId);
            locationContentBlocks.value[locationId] = contentBlocks;
        }
    }
});

const selectedContentBlocks = computed(() => {
    if (!selectedLocation?.value) {
        return [];
    }
    return locationContentBlocks.value[selectedLocation.value.id];
});

const pageTitle = computed(() => (
    locations.value.length === 1
        ? `Site Information ${locations.value[0].name}`
        : "Site Information"
));
</script>

<style lang="scss" scoped>
.location-select {
    width: 100%;
    max-width: 24rem;
}
</style>
